module.exports = __webpack_public_path__ + "img/no-inbox.3913ea6e.svg";